<template>
  <div class="wrapper" style="margin-top: 6rem">
    <div class="bg"></div>
    <b-container>
      <div class="title">
        <div class="left">
          <h1>{{ zhData[dataIndex].title }}</h1>
          <h3>{{ zhData[dataIndex].etitle }}</h3>
        </div>
        <div class="right" @click="showShare">
          <div class="share" v-show="shareShow" @mouseleave.stop="removeShare">
            <ul>
              <li v-for="(value, indexImg) in shareArr" :key="indexImg">
                <a
                  class="share-bg"
                  @mouseenter.stop="changeActive($event)"
                  @mouseleave.stop="removeActive($event)"
                  :href="value.url + wPath"
                  target="_blank"
                >
                  <img :src="value.icon" alt="" />
                  <p>{{ value.name }}</p>
                </a>
              </li>
              <li>
                <div
                  class="share-bg"
                  @click.stop="copy()"
                  @mouseenter.stop="changeActive($event)"
                  @mouseleave.stop="removeActive($event)"
                >
                  <img src="../../assets/link.png" alt="" />
                  <p>复制链接</p>
                </div>
              </li>
            </ul>
            <div class="share-right">
              <div class="erweima" id="qrcode" ref="qrcode"></div>
              <p class="wxEwm">使用微信扫一扫</p>
            </div>
          </div>
        </div>
      </div>
      <div class="video-box">
        <div v-if="flag" class="video">
          <iframe
            style="width: 100%; height: 100%"
            :src="zhData[dataIndex].list[agendaIndex].playbackUrl"
            frameborder="0"
            scrolling="no"
            marginwidth="0"
            marginheight="0"
            align="center"
          ></iframe>
        </div>
        <div v-else class="video">
          <div class="video-top">
            正在播放：{{ zhData[dataIndex].list[agendaIndex].title }}
          </div>
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
        <div class="lists">
          <div class="lists-top">
            <div
              v-for="(item, index) in zhData"
              :key="index"
              :class="['items', { active: index === dataIndex }]"
              @click="changeTab(index)"
            >
              {{ item.time }}
            </div>
          </div>
          <dl class="item">
            <dt>{{ zhData[dataIndex].title }}</dt>
            <dd
              v-for="(itemList, indexList) in zhData[dataIndex].list"
              :key="indexList"
              @click="changeVideo(indexList)"
              :class="{ active: indexList == agendaIndex }"
            >
              <div class="timec">
                {{ itemList.startTime }} ~ {{ itemList.endTime }}
              </div>
              <div class="titlec">{{ itemList.title }}</div>
            </dd>
          </dl>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import zh from "@/common/xdata/zh";
import en from "@/common/xdata/en";
export default {
  data() {
    return {
      lang: "",
      projectId: "",
      zhData: [],
      enData: [],
      dataIndex: 0,
      agendaIndex: 0,
      flag: "",
      shareShow: false,
      wPath: "",
      hrefShare: "",
      playerOptions: {
        width: 400,
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // src: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8",
            src: "",
            type: "video/mp4",
          },
        ],
        poster: "", //封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      shareArr: [
        {
          icon: require("../../assets/Twitter.png"),
          name: "Twitter",
          url: "https://twitter.com/intent/tweet?text=",
        },
        {
          icon: require("../../assets/facebook.png"),
          name: "Facebook",
          url: "https://www.facebook.com/sharer/sharer.php?u=",
        },
        {
          icon: require("../../assets/d-weibo.png"),
          name: "微博",
          url: "https://service.weibo.com/share/share.php?url=",
        },
      ],
    };
  },
  watch: {
    lang: function () {
      if (this.lang === "en") {
        if (this.projectId === "3") {
          this.zhData = en.live2019;
        } else if (this.projectId === "1") {
          this.zhData = en.live2020;
        } else {
          this.zhData = en.live2021;
        }
      } else {
        if (this.projectId === "3") {
          this.zhData = zh.live2019;
        } else if (this.projectId === "1") {
          this.zhData = zh.live2020;
        } else {
          this.zhData = zh.live2021;
        }
      }
    },
  },
  created() {
    this.lang = localStorage.getItem("LANG");
    this.projectId = localStorage.getItem("BIGWEEKYEAR") || "2020";
    if (this.projectId === "3") {
      this.zhData = zh.live2019;
    } else if (this.projectId === "1") {
      this.zhData = zh.live2020;
    } else {
      this.zhData = zh.live2021;
    }
    this.flag = this.zhData[0].list[0].playbackUrl;
  },
  mounted() {
    // 点击空白地方隐藏分享
    // document.body.addEventListener(
    //   "click",
    //   () => {
    //     this.shareShow = false;
    //   },
    // );
  },
  methods: {
    // 切焕小tab
    changeTab(index) {
      this.dataIndex = index;
      this.agendaIndex = 0;
      this.flag =
        this.zhData[this.dataIndex].list[this.agendaIndex].playbackUrl;
      this.playerOptions.sources.src =
        this.zhData[this.dataIndex].list[this.agendaIndex].pullFlowUrl;
    },
    // 切焕tab议程
    changeVideo(index) {
      this.agendaIndex = index;
      this.flag =
        this.zhData[this.dataIndex].list[this.agendaIndex].playbackUrl;
      this.playerOptions.sources.src =
        this.zhData[this.dataIndex].list[this.agendaIndex].pullFlowUrl;
    },
    // 分享
    showShare() {
      if (this.shareShow) {
        this.shareShow = false;
        return;
      }
      this.shareShow = true;
      this.hrefShare = window.document.location.href;
      this.wPath = encodeURIComponent(this.hrefShare);
      this.qrcodeScan();
    },
    removeShare() {
      this.shareShow = false;
    },
    changeActive($event) {
      $event.currentTarget.className = "active share-bg";
      this.shareShow = true;
    },
    removeActive($event) {
      $event.currentTarget.className = "share-bg";
    },
    // 生成分享二维码
    qrcodeScan() {
     this.$refs.qrcode.innerHTML = ''
      //生成二维码
      let qrCode = new QRCode("qrcode", {
        width: 75, //二维码宽度，单位像素
        height: 75, //二维码高度，单位像素
        // text: "https://v.qq.com/txp/iframe/player.html?vid=j3216sv2mi8", //二维码中的内容
        text: this.hrefShare, //二维码中的内容
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别，
      });
    },
    // 复制链接到剪切板
    copy() {
      let url = this.hrefShare;
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      // this.$notifice("success", "复制成功");
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
      alert("复制成功");
    },
  },
  components: { QRCode },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
  .video-box {
    width: 100%;
    flex-direction: column;
    .video {
      height: 550px;
      width: 100% !important;
      iframe {
        height: 550px;
      }
    }
    .lists {
      margin-top: 2rem;
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .video {
    width: 375px !important;
    height: 200px !important;
    iframe {
      height: 200px !important;
    }
  }
  .lists {
    margin-top: 2rem;
    width: 100% !important;
    height: 250px !important;
  }
  .container {
    .title {
      height: 70px;
      .left {
        h1 {
          font-size: 1.4rem !important;
        }
        h3 {
          font-size: 0.7rem;
        }
      }
      .right {
        margin-top: 1rem;
        .share {
          transform: scale(0.5);
          right: -4.5rem;
          top: -4.5rem;
          z-index: 2;
          .wxEwm {
            display: none;
          }
        }
      }
    }
  }
}
h1,
h3 {
  margin: 0;
}
.title {
  position: relative;
  padding-top: 4rem;
  display: flex;
  justify-content: space-between;
  .left {
    h1 {
      font-weight: normal !important;
      color: #11206f;
      font-size: 2.4rem !important;
    }
    h3 {
      font-weight: normal !important;
      color: #11206f;
      font-size: 1.7rem;
    }
  }
  .right {
    position: relative;
    margin-top: 2.5rem;
    width: 20px;
    height: 20px;
    background: url("../../assets/share1.png") no-repeat;
    background-size: cover;
  }
}
.video-box {
  padding-top: 2.15rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .video {
    width: 68%;
    height: 477px;
    .video-top {
      height: 2.1rem;
      line-height: 2.1rem;
      width: 100%;
      background: -webkit-linear-gradient(top, #11205b, #09112f);
      color: #fff;
      font-size: 0.86rem;
      text-indent: 1rem;
      border-bottom: 3px solid #f5d388;
    }
  }
  .lists {
    background-color: #fff;
    width: 30%;
    border: 1px solid #11206f;
    border-top: none;
    .lists-top {
      width: 100%;
      height: 2.1rem;
      line-height: 2.1rem;
      display: flex;
      align-items: center;
      background-color: #11206f;
      color: #e9c881;
      .items {
        flex: 1;
        height: 2.1rem;
        line-height: 2.1rem;
        text-align: center;
        &.active {
          background-color: #e9c881;
          color: #11206f;
        }
      }
    }
    .item {
      cursor: pointer;
      dt {
        margin: 0.86rem 0 0 1rem;
        border-left: 1px solid #999999;
        position: relative;
        text-indent: 1.3rem;
        height: 4.6rem;
        line-height: 4.6rem;
        &::after {
          content: "";
          display: block;
          width: 0.86rem;
          height: 0.86rem;
          border-radius: 50%;
          background-color: #cccccc;
          position: absolute;
          left: -0.45rem;
          top: 1.7rem;
        }
      }
      dd {
        padding-right: 1rem;
        margin: 0px 0 0 1rem;
        border-left: 1px solid #999999;
        position: relative;
        padding-top: 0.86rem;
        .timec {
          margin-left: 1.5rem;
        }
        .titlec {
          margin-left: 1.5rem;
          font-size: 1rem;
        }
        &.active::after {
          content: "";
          display: block;
          width: 0.86rem;
          height: 0.86rem;
          background: url("../../assets/round.png") no-repeat;
          background-size: cover;
          position: absolute;
          left: -0.45rem;
          top: 1.7rem;
        }
        &.active::before {
          content: "";
          display: block;
          width: 0.6rem;
          height: 0.6rem;
          background: url("../../assets/san.png") no-repeat;
          background-size: cover;
          position: absolute;
          left: 0.5rem;
          top: 1.85rem;
        }
        &::after {
          content: "";
          display: block;
          width: 0.86rem;
          height: 0.86rem;
          border-radius: 50%;
          background-color: #cccccc;
          position: absolute;
          left: -0.44rem;
          top: 1.7rem;
        }
      }
    }
  }
}
.bg {
  width: 137.1rem;
  height: 65rem;
  background: url("../../assets/bg.png") no-repeat;
  background-size: cover;
  position: fixed;
  left: 0;
  top: 2.15rem;
  z-index: -1;
}
a {
  color: #757575;
}
.share {
  font-size: 0.86rem;
  position: absolute;
  right: 2rem;
  top: -6.8rem;
  display: flex;
  padding: 1rem 0;
  background-color: #fff;
  box-shadow: 0px 0px 0px 2px #e7e7e7;
  border-radius: 0.71rem;
  cursor: pointer;
  ul {
    display: flex;
    width: 17.85rem;
    height: 5.35rem;
    li {
      position: relative;
      width: 25%;
      .share-bg {
        width: 100%;
        &::before {
          content: "";
          display: block;
          width: 2.5rem;
          height: 2.5rem;
          background-color: #757575;
          border-radius: 50%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        img {
          width: 2rem;
          height: 2rem;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        p {
          margin-top: 4.28rem;
          text-align: center;
        }
        &.active {
          &::before {
            background-color: #112070;
          }
          color: #112070 !important;
        }
      }
    }
  }
  .share-right {
    width: 8.57rem;
    height: 5.71rem;
    border-left: 1px solid #ccc;
    .erweima {
      margin: 0 auto;
      width: 5.35rem;
      height: 5.35rem;
      border: 1px solid #ccc;
    }
    p {
      text-align: center;
      font-size: 0.85rem;
    }
  }
}
</style>